import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@knockrentals/knock-react';

const GroupUserDeleteConfirm = ({
  handleDeleteOnClick,
  onBack,
  onCancel,
  transferRecipientUsername,
  username,
}) => (
  <div className="group-user-delete-confirm">
    <Modal>
      <ModalHeader>
        <h3>
          {`Delete ${username} and transfer data to ${transferRecipientUsername}`}
        </h3>
      </ModalHeader>

      <ModalContent>
        <div className="confirmation-message">
          <h4>Deletion is permanent and cannot be undone.</h4>
          {`Are you sure you want to delete ${username}?`}
        </div>
      </ModalContent>

      <ModalFooter>
        <button className="knock-react-button" onClick={onCancel}>
          Cancel
        </button>

        <button className="knock-react-button" onClick={onBack}>
          Back
        </button>

        <button
          className="knock-react-button danger"
          onClick={handleDeleteOnClick}
        >
          Transfer and Delete
        </button>
      </ModalFooter>
    </Modal>
  </div>
);

GroupUserDeleteConfirm.propTypes = {
  handleDeleteOnClick: PropTypes.func,
  onBack: PropTypes.func,
  onCancel: PropTypes.func,
  transferRecipientUsername: PropTypes.string,
  username: PropTypes.string,
};

export default GroupUserDeleteConfirm;
